// GraphQL response
export enum UserNotificationType {
    SNAPSHOT_GENERATION = 'SNAPSHOT_GENERATION',
    BULK_SNAPSHOT_GENERATION = 'BULK_SNAPSHOT_GENERATION',
}

// Equivalent enum values from BE (WebSocket response)
export const UserNotificationTypeBEEnum = {
    [UserNotificationType.SNAPSHOT_GENERATION]: 19,
    [UserNotificationType.BULK_SNAPSHOT_GENERATION]: 20,
};

// Reverse mapping so that we can convert UserNotificationTypeBEEnum to UserNotificationType easier
export const BEEnumToUserNotificationType = Object.fromEntries(
    Object.entries(UserNotificationTypeBEEnum).map(([key, value]) => [value, key]),
) as Record<number, UserNotificationType>;
